import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useState } from 'react';
import Lottie from 'lottie-react';
import Avatar, { AVATAR_SIZES } from '@atlaskit/avatar';
import ProfileCardTrigger from '@atlaskit/profilecard/user';
import { AvatarSkeleton, AvatarWrapper } from '../../avatar-layout';
import { AvatarContainer as BlankAvatarSkeleton } from '../../notification-item-skeleton/styled';
import { useProfileClient } from '../../use-profile-client';
import { isProduction } from '../utils';
var animationStyle = {
  width: "".concat(AVATAR_SIZES['large'], "px"),
  height: "".concat(AVATAR_SIZES['large'], "px"),
  margin: "var(--ds-space-025, 2px)"
};
var DEFAULT_AVATAR_URL = "https://avatar-management--avatars.us-west-2.".concat(isProduction() ? 'prod' : 'staging', ".public.atl-paas.net/default-avatar.png");
function AvatarContainer(_ref) {
  var _actors$4, _actors$5, _actors$6, _actors$7;
  var actors = _ref.actors,
    propUserId = _ref.userId;
  var userId = useMemo(function () {
    var _actors$;
    return propUserId !== null && propUserId !== void 0 ? propUserId : (_actors$ = actors[0]) === null || _actors$ === void 0 || (_actors$ = _actors$.ari) === null || _actors$ === void 0 ? void 0 : _actors$.split('/')[1];
  }, [actors, propUserId]);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    animationData = _useState2[0],
    setAnimationData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    animationHasError = _useState4[0],
    setAnimationHasError = _useState4[1];
  useEffect(function () {
    var _actors$2, _actors$3;
    if (((_actors$2 = actors[0]) === null || _actors$2 === void 0 ? void 0 : _actors$2.actorType) === 'animated' && !((_actors$3 = actors[0]) !== null && _actors$3 !== void 0 && _actors$3.avatarUrl.endsWith('gif'))) {
      var fetchAnimation = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var response, data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(actors[0].avatarUrl);
              case 3:
                response = _context.sent;
                if (response.ok) {
                  _context.next = 8;
                  break;
                }
                setAnimationHasError(true);
                _context.next = 12;
                break;
              case 8:
                _context.next = 10;
                return response.json();
              case 10:
                data = _context.sent;
                setAnimationData(data);
              case 12:
                _context.next = 17;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                setAnimationHasError(true);
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 14]]);
        }));
        return function fetchAnimation() {
          return _ref2.apply(this, arguments);
        };
      }();
      fetchAnimation();
    }
  }, [actors]);
  var profileClient = useProfileClient();
  if (!actors.length) {
    return /*#__PURE__*/React.createElement(AvatarSkeleton, null);
  }
  if (((_actors$4 = actors[0]) === null || _actors$4 === void 0 ? void 0 : _actors$4.actorType) === 'animated' && !((_actors$5 = actors[0]) !== null && _actors$5 !== void 0 && _actors$5.avatarUrl.endsWith('gif')) && !animationData && !animationHasError) {
    // Animation is loading
    return /*#__PURE__*/React.createElement(BlankAvatarSkeleton, null);
  }
  if (animationHasError) {
    // Animation failed to load
    return /*#__PURE__*/React.createElement(AvatarWrapper, {
      "data-testid": "avatar-wrapper"
    }, /*#__PURE__*/React.createElement(Avatar, {
      appearance: "circle",
      size: "large",
      src: DEFAULT_AVATAR_URL
    }));
  }
  var avatar = ((_actors$6 = actors[0]) === null || _actors$6 === void 0 ? void 0 : _actors$6.actorType) === 'animated' && !((_actors$7 = actors[0]) !== null && _actors$7 !== void 0 && _actors$7.avatarUrl.endsWith('gif')) ? /*#__PURE__*/React.createElement(Lottie, {
    animationData: animationData,
    loop: false,
    style: animationStyle
  }) : /*#__PURE__*/React.createElement(Avatar, {
    name: actors[0].displayName,
    appearance: "circle",
    src: actors[0].avatarUrl,
    size: "large"
  });
  return /*#__PURE__*/React.createElement(AvatarWrapper, {
    "data-testid": "avatar-wrapper"
  }, userId ? /*#__PURE__*/React.createElement(ProfileCardTrigger, {
    trigger: "hover",
    userId: userId,
    resourceClient: profileClient,
    testId: "profile-card-trigger-".concat(userId)
  }, avatar) : avatar);
}
export default AvatarContainer;